(function(){
  'use strict';

  angular.module('clientDashboardApp').service('pageTrackingService',[PageTrackingService]);

  function PageTrackingService(){
    this.lastUrl = null;
    this.currentUrl = null;
  }

  PageTrackingService.prototype.updateCurrentUrl = function(url){
    if(this.currentUrl){
      this.lastUrl = this.currentUrl;
    }
    this.currentUrl = url;
  }

  PageTrackingService.prototype.getCurrentUrl = function(){
    return this.currentUrl;
  }

  PageTrackingService.prototype.getLastUrl = function(){
    return this.lastUrl;
  }

  PageTrackingService.prototype.pageUsesUpdates = function(url){
    if(!url){
      var url = this.getCurrentUrl();
    }
    return url.search(/^\/admin|\/reviewBuilder/) >= 0;
  }


})();

